import { corporationAtom } from '@/state/atom/corporationAtom';
import { closePanelTabSelector, setPanelSelector, updateParamIsCustomerKnowledgeDrilldown } from '@/state/selector/panelSelector';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import LoadingPanel from '../common/LoadingPanel';
import FirstMessageContent from './element/FirstMessageContent';
import GroupButtonKnowledge from './element/GroupButtonKnowledge';
import InputChatAI from './element/InputChatAI';
import ListMessageChatAI from './element/ListMessageChatAI';
import { getProjectInfo, isValidSearchConditionData, onSubscriptionEventUpdateCorporation, updateChatAIInvalidPreconditionStatus } from './handler/ChatAIHandler';
import { getListMessageChat, getNameTabChatAiWhenFirstMsgNoContent } from '@/service/chatAIService';

import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import AiAutoConstant from "@/common/constant/AiAutoConstant";
import {showLoadingMouse, hideLoadingMouse} from '@/common/utils/CustomCursor';

import { userAtom, userPermissionToViewKnowledgeAtom } from '@/state/atom/userAtom';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { API, I18n } from "aws-amplify";
import { multiPanelAtom } from '@/state/atom/panelAtom';
import { cloneDeep } from 'lodash';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import DataChangePleaseReloadModal from '../common/modal/DataChangePleaseReloadModal';
import { helpdeskTicketLastUserActionAtom, publicKnowledgeHitNumberTicketAtom } from '@/state/atom/ticketAtom';
import { projectIdListUserIsB2CAtom } from '@/state/atom/projectAtom';
import { openShareLinkTicket } from '../chatThread/handler/MessageHandler';
import {getProductByIdAPI} from '@/service/productManagementService';
import { getCorporationById, getCorporationDetailByCorporationDomain } from '@/service/organizationService';
import './ChatAIPanel.css';

import APIAmplify from '@aws-amplify/api';
import { onAIChatPostCreated } from '@/graphql/subscriptions';
import { PropTypes } from 'prop-types';
import OpenAiUtil from '@/common/utils/OpenAiUtil';

// MCP Server service import
import { getMCPServer, getMcpServerByOwnerBy } from '@/service/mcpServerService';

const INITIAL_PERSONAL_CONNECTOR_SERVICES = {
    [Constant.PERSONAL_CONNECTOR_SERVICE_NAME.DROPBOX]: {
        id: Constant.PERSONAL_CONNECTOR_COMMON_ID.DROPBOX,
        name: Constant.PERSONAL_CONNECTOR_SERVICE_NAME.DROPBOX,
        type: Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR_PERSONAL,
        no: 1
    },
    [Constant.PERSONAL_CONNECTOR_SERVICE_NAME.GMAIL]: {
        id: Constant.PERSONAL_CONNECTOR_COMMON_ID.GMAIL,
        name: Constant.PERSONAL_CONNECTOR_SERVICE_NAME.GMAIL,
        type: Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR_PERSONAL,
        no: 2
    },
    [Constant.PERSONAL_CONNECTOR_SERVICE_NAME.GOOGLE_CALENDAR]: {
        id: Constant.PERSONAL_CONNECTOR_COMMON_ID.GOOGLE_CALENDAR,
        name: Constant.PERSONAL_CONNECTOR_SERVICE_NAME.GOOGLE_CALENDAR,
        type: Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR_PERSONAL,
        no: 3
    },
    [Constant.PERSONAL_CONNECTOR_SERVICE_NAME.GOOGLE_DRIVE]: {
        id: Constant.PERSONAL_CONNECTOR_COMMON_ID.GOOGLE_DRIVE,
        name: Constant.PERSONAL_CONNECTOR_SERVICE_NAME.GOOGLE_DRIVE,
        type: Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR_PERSONAL,
        no: 4
    },
    [Constant.PERSONAL_CONNECTOR_SERVICE_NAME.MICROSOFT_TEAM]: {
        id: Constant.PERSONAL_CONNECTOR_COMMON_ID.MICROSOFT_TEAM,
        name: Constant.PERSONAL_CONNECTOR_SERVICE_NAME.MICROSOFT_TEAM,
        type: Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR_PERSONAL,
        no: 5
    },
    [Constant.PERSONAL_CONNECTOR_SERVICE_NAME.OUTLOOK_GMAIL]: {
        id: Constant.PERSONAL_CONNECTOR_COMMON_ID.OUTLOOK_GMAIL,
        name: Constant.PERSONAL_CONNECTOR_SERVICE_NAME.OUTLOOK_GMAIL,
        type: Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR_PERSONAL,
        no: 6
    },
    [Constant.PERSONAL_CONNECTOR_SERVICE_NAME.OUTLOOK_CALENDAR]: {
        id: Constant.PERSONAL_CONNECTOR_COMMON_ID.OUTLOOK_CALENDAR,
        name: Constant.PERSONAL_CONNECTOR_SERVICE_NAME.OUTLOOK_CALENDAR,
        type: Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR_PERSONAL,
        no: 7
    },
    [Constant.PERSONAL_CONNECTOR_SERVICE_NAME.SHAREPOINT]: {
        id: Constant.PERSONAL_CONNECTOR_COMMON_ID.SHAREPOINT,
        name: Constant.PERSONAL_CONNECTOR_SERVICE_NAME.SHAREPOINT,
        type: Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR_PERSONAL,
        no: 8
    }
};

ChatAI.propTypes = {
    panelId: PropTypes.any,
    tabId: PropTypes.any,
    tabNameChatAI: PropTypes.any,
    filterKnowledgeListData: PropTypes.any
};

export default function ChatAI(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);
    const [listMessageContent, setListMessageContent] = useState([]);
    const [projectInfo, setProjectInfo] = useState({});
    const [titleTicket, setTitleTicket] = useState('');
    const [basicPrompt, setBasicPrompt] = useState('');
    const [promptInternalTicket, setPromptInternalTicket] = useState({});
    const [promptExternalTicket, setPromptExternalTicket] = useState({});
    const [triggerReload, setTriggerReload] = useState('');
    const [isLoadingMessage, setIsLoadingMessage] = useState(true);
    const [currentUserDetail, setCurrentUserDetail] = useRecoilState(userAtom);
    const [isReloadPage, setIsReloadPage] =  useState(false);
    const [userSelectedPrompt, setUserSelectedPrompt] = useState([]);
    const [isEnableBtnSend, setIsEnableBtnSend] = useState(true);
    const [corporationSelected, setCorporationSelected] = useState('');
    const [isInvalidSearchCondition, setIsInvalidSearchCondition] = useState(false);
    const [isUsingKnowledgeService, setIsUsingKnowledgeService] = useState(false);
    const [isOpenPopupKnowledgeOff, setIsOpenPopupKnowledgeOff] = useState(false);
    const [isOpenAccessDeniedPopup, setIsOpenAccessDeniedPopup] = useState(false);
    const [isOpenNotFoundTicketPopup,setIsOpenNotFoundTicketPopup] = useState(false);
    const [isEnableMcpInVersion, setIsEnableMcpInVersion] = useState(true)
    
    const [idOfResponseMessage,setIdOfResponseMessage] = useState('')
    const [showPopupSingleButtonError, setShowPopupSingleButtonError] = useState({
        isShow: false,
        message: I18n.get('MSG-CM-DELETED-CONTENT'),
        confirmTxt: I18n.get('CM-BUTTON-OK')
    });
    const [aiAutoPromptTitle, setAiAutoPromptTitle] = useState('')

    // MCP Server state management
    const [mcpServerOptions, setMcpServerOptions] = useState([]);

    const { enqueueSnackbar } = useSnackbar();

    const corporationDetail = useRecoilValue(corporationAtom);
    const totalTickets = useRecoilValue(publicKnowledgeHitNumberTicketAtom);
    const userPermissionView = useRecoilValue(userPermissionToViewKnowledgeAtom);
    const [projectInuseDetail, setProjectInuseDetail] = useRecoilState(projectInuseDetailAtom);

    const reloadKnowledgeDrilldownIsCustomerParams = useSetRecoilState(updateParamIsCustomerKnowledgeDrilldown);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const addNewPanel = useSetRecoilState(setPanelSelector);
    const setProjectIdListUserIsB2CAtom = useSetRecoilState(projectIdListUserIsB2CAtom);
    const setLastUserAction = useSetRecoilState(helpdeskTicketLastUserActionAtom);
    
    const filterKnowledgeListData = props?.filterKnowledgeListData;
    const chatThreadId = filterKnowledgeListData?.threadId;
    const isAiAutoLog = !!filterKnowledgeListData?.aiAutoLog;

    const [isShowButtonStop, setIsShowButtonStop] = useState(false);
    const [isOnlyRunChatAI, setIsOnlyRunChatAI] = useState(false);
    const [streamedContent, setStreamedContent] = useState('');
    const [isStopStreamContent, setIsStopStreamContent] = useState('');
    const [selectedCorporationDetail, setSelectedCorporationDetail] = useState({});
    const [chatGPTModelListOptions, setChatGPTModelListOptions] = useState([]);

    const getVersionIdOfCorporation = async corporationSelectedId => {
        if (corporationSelectedId === corporationDetail.id) {
            setSelectedCorporationDetail(cloneDeep(corporationDetail));
            return {versionId: corporationDetail.versionId, corporationOfFilterKnowledgeList: corporationDetail};
        } else {
            let corporationOfFilterKnowledgeList = await getCorporationById(API, corporationSelectedId);
            setSelectedCorporationDetail(corporationOfFilterKnowledgeList);
            return {versionId: corporationOfFilterKnowledgeList.versionId, corporationOfFilterKnowledgeList: corporationOfFilterKnowledgeList};
        }
    };

    const fetchMcpServers = async () => {
        try {
            let corporationSelectedId = '';
            let projectSelectedId = '';
            if (filterKnowledgeListData?.projectSelectedId?.includes('project_')) {
                projectSelectedId = filterKnowledgeListData.projectSelectedId;
                corporationSelectedId = filterKnowledgeListData.ticketCreatedCorporationId;
            } else {
                corporationSelectedId = corporationDetail.id;
                projectSelectedId = projectInuseDetail.id;
            }
            let { versionId, corporationOfFilterKnowledgeList } = await getVersionIdOfCorporation(
                corporationSelectedId
            );

            if (chatGPTModelListOptions.length === 0) {
                const chatGptModelList = OpenAiUtil.getListChatGptModelFromCorpDetail(corporationOfFilterKnowledgeList);
                setChatGPTModelListOptions(chatGptModelList);
            }
            
            let [response, versionDetail] = await Promise.all([
                getMCPServer({
                    corporationInuse: corporationSelectedId,
                    projectInuse: projectSelectedId,
                    getMethod: Constant.MCP_SERVER_GET_METHOD.GET_LIST_ACTIVE_MCP_BY_PROJECT,
                    userId: currentUserDetail.id
                }),
                // getMcpServerByOwnerBy(
                //     currentUserDetail.affiliationOrganization,
                //     currentUserDetail.id
                // ),
                getProductByIdAPI(props.API, versionId),
            ]);


            let moduleSetting = Utils.convertJSONDataToObject(versionDetail?.moduleSetting);
            const limitValue = Utils.convertJSONDataToObject(
                corporationOfFilterKnowledgeList?.limitValue
            );
            let isCorporationOnMcpServer = limitValue?.hasOwnProperty('mcpServer')
                ? limitValue?.mcpServer
                : moduleSetting?.mcpServer;
            setIsEnableMcpInVersion(isCorporationOnMcpServer);
            let payload = Utils.convertJSONDataToObject(response.payload);
            let listOptionMcpServer = [];
            let listOptionPersonalConnector = [];
            if (response?.success && payload?.listItem && projectInuseDetail.type !== Constant.PROJECT_TYPE.BASE) {
                // Transform MCP server data to server list format
                let serverList = payload?.listItem?.map(server => ({
                    id: server.id,
                    name: server.serverName || server.serverName || 'Unknown Server',
                    createdAt: server.createdAt,
                    type: server.type
                }));

                serverList = serverList?.sort((a, b) => {
                    const dateA = new Date(a.createdAt);
                    const dateB = new Date(b.createdAt);
                    return dateB - dateA;
                });

                listOptionMcpServer = [...serverList];
            }
            // comment personal connector
            // let listRecord = [];
            // listRecord = personalConnectorList?.map(server => {
            //     let isConnected = server.status === Constant.MCP_SERVER_CONNECT_STATUS.SUCCESS;
            //     let baseServerName = server.serverName || server.serverName || 'Unknown Server';
            //     return {
            //         recordId: server.id,
            //         name: baseServerName,
            //         createdAt: server.createdAt,
            //         type: server.type,
            //         isConnected: isConnected,
            //         baseServerName: baseServerName
            //     };
            // });

            // for (const personalConnectorName in INITIAL_PERSONAL_CONNECTOR_SERVICES) {
            //     if (
            //         Object.prototype.hasOwnProperty.call(
            //             INITIAL_PERSONAL_CONNECTOR_SERVICES,
            //             personalConnectorName
            //         )
            //     ) {
            //         const personalConnector =
            //             INITIAL_PERSONAL_CONNECTOR_SERVICES[personalConnectorName];

            //         let recordIndex = listRecord?.findIndex(
            //             record => record.name === personalConnector.name
            //         );
            //         if (recordIndex === -1) {
            //             listRecord.push({
            //                 id: personalConnector.id,
            //                 name: personalConnector.name,
            //                 createdAt: personalConnector.createdAt,
            //                 type: personalConnector.type,
            //                 isConnected: false,
            //                 no: personalConnector.no
            //             });
            //         } else {
            //             let record = listRecord[recordIndex];
            //             record.id = personalConnector.id;
            //             listRecord[recordIndex] = {...record, no: personalConnector.no};
            //         }
            //     }
            // }

            // listRecord = listRecord?.sort((a, b) => {
            //     const aNo = typeof a.no === 'number' ? a.no : Number.MAX_SAFE_INTEGER;
            //     const bNo = typeof b.no === 'number' ? b.no : Number.MAX_SAFE_INTEGER;

            //     if (aNo === Number.MAX_SAFE_INTEGER && bNo === Number.MAX_SAFE_INTEGER) return 0;
            //     if (aNo === Number.MAX_SAFE_INTEGER) return 1;
            //     if (bNo === Number.MAX_SAFE_INTEGER) return -1;
            //     return aNo - bNo;
            // });

            // listRecord = listRecord?.map(personalConnector => {
            //     return {
            //         id: personalConnector.id,
            //         name: personalConnector.isConnected
            //             ? `${personalConnector.name} (${I18n.get('AUTHENTICATED')})`
            //             : `${personalConnector.name} (${I18n.get('NOT_AUTHENTICATED')})`,
            //         createdAt: personalConnector.createdAt,
            //         type: personalConnector.type,
            //         isConnected: personalConnector.isConnected
            //     };
            // });

            // listOptionPersonalConnector = [...listRecord];

            // setMcpServerOptions([...listOptionMcpServer, ...listOptionPersonalConnector]);
            setMcpServerOptions([...listOptionMcpServer]);
            if (filterKnowledgeListData?.hasOwnProperty('listSelectedMcp')) {
                setSelectedMcpServers(filterKnowledgeListData.listSelectedMcp);
            }
        } catch (error) {
            console.log('fetchMcpServers error:', error);
            setMcpServerOptions([]);
        }
    };

    useEffect(() => {
        if (!corporationSelected) return;

        let subscription;

        const listenEventUpdateSelectedCorporation = async () => {
            let selectedCorporationDetail =
            corporationSelected === corporationDetail?.id
                ? corporationDetail
                : await getCorporationById(null, corporationSelected);
                
            if (selectedCorporationDetail) {
                let subscriptionCorpId = corporationSelected;
                if (
                    [Constant.CORPORATION_CONTRACT_TYPE.GUEST, Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(selectedCorporationDetail.contractType)
                ) {
                    subscriptionCorpId = selectedCorporationDetail.inviter
                }
                subscription = onSubscriptionEventUpdateCorporation(
                    subscriptionCorpId,
                    setIsReloadPage
                );
            }
        };

        listenEventUpdateSelectedCorporation();

        return () => {
            if (subscription) {
                subscription?.unsubscribe();
            }
        };
    },[corporationSelected, corporationDetail])

    useEffect(() => {
        if (Utils.isEmptyString(chatThreadId)) return;

        const controller = new AbortController();

        if (!Utils.isEmptyString(chatThreadId)) {
            let aiAutoLog = filterKnowledgeListData?.aiAutoLog;
            if (aiAutoLog) {
                setIsLoading(true);
                showLoadingMouse();
            }
            
            getListMessageChat(props?.API, chatThreadId, aiAutoLog?.ticketId).then(async result => {
                if (result === false) {
                    closePanelTab({
                        event: null,
                        panelType: Constant.PANEL_TYPE.OPEN_CHAT_AI,
                        panelId: props.panelId,
                        tabId: chatThreadId
                    })
                } 
                result = Utils.sortByCreatedAtAsc(result);
                const firstChatMsg = result[0];
                
                let threadStatus = firstChatMsg?.threadStatus;
                let tabNameChatAI = props?.tabNameChatAI || '';
                if (!Utils.isEmptyArray(result)) {
                    // Get Full_TabNameChatAI
                    tabNameChatAI = firstChatMsg?.content;
                    if (
                        Utils.isEmptyString(tabNameChatAI) &&
                        firstChatMsg.postType === Constant.POST_TYPE.IMAGE
                    ) {
                        tabNameChatAI = await getNameTabChatAiWhenFirstMsgNoContent(firstChatMsg);
                    }

                    if (aiAutoLog) {
                        aiAutoLog.tabName = firstChatMsg.content;
                        setAiAutoPromptTitle(firstChatMsg.ticketOutline || '');
                    }
                    let chatHistory = [];
                    let showContentMsg = ['MSG-AI-AUTO-LOG-PAUSE', 'MSG-AI-AUTO-LOG-RETRY', 'MSG-AI-AUTO-LOG-ERROR']
                    result?.forEach(message => {
                        if (message.role === 'user') {
                            let content = message.content;

                            chatHistory.push({
                                isFromMe: true,
                                user: aiAutoLog
                                    ? `${message?.creatorName || ''} (オート)`
                                    : Utils.getFullNameOfUser(
                                          Constant.LANGUAGE_TYPE.JP,
                                          currentUserDetail
                                      ),
                                dateTime: aiAutoLog
                                    ? Utils.getJSTDateTimeYYYY_MM_DDHHMM(message.createdAt)
                                    : Utils.getDateTimeByFormatJapanYYYY_MM_DDHHMM(
                                          message.createdAt
                                      ),
                                content:
                                    aiAutoLog && showContentMsg.includes(content)
                                        ? I18n.get(content)
                                        : content,
                                isHidden: aiAutoLog && content === 'MSG-AI-AUTO-LOG-REPLAY',
                                postType: message.postType || Constant.POST_TYPE.MSG,
                                id: message.id
                            });
                        } else {
                            let reasoningData = [];
                            if (!Utils.isEmptyArray(message.reasoning)) {
                                reasoningData = message.reasoning.map(reasoning =>
                                    Utils.extractTitleAndContent(reasoning)
                                );
                                reasoningData.push({ isDone: true });
                            }

                            let aiMessage = {
                                isFromMe: false,
                                dateTime: aiAutoLog
                                    ? Utils.getJSTDateTimeYYYY_MM_DDHHMM(message.createdAt)
                                    : Utils.getDateTimeByFormatJapanYYYY_MM_DDHHMM(
                                          message.createdAt
                                      ),
                                content: message.content,
                                postType: message.postType || Constant.POST_TYPE.MSG,
                                id: message.id,
                                reasoningData: reasoningData
                            };

                            if (filterKnowledgeListData.isOperatorPromptLog) {
                                aiMessage.user = message.creatorId;
                                aiMessage.isOperatorPromptLog = true
                            }

                            chatHistory.push(aiMessage);
                        }
                    });

                    if (aiAutoLog && threadStatus === AiAutoConstant.AICHATTHREAD_LOG_STATUS.RUNNING) {
                        chatHistory.push({
                            isFromMe: false,
                            isLoadingMessage: true
                        })
                    }
                    setListMessageContent([...chatHistory])
                }

                let currentPanelList = cloneDeep(panelList);
                if (Utils.isEmptyArray(currentPanelList)) return;
                let currentPanelIndex = Utils.findIndexInArrayById(props.panelId, currentPanelList);
                if (currentPanelIndex === -1) return;

                let currentPanel = currentPanelList[currentPanelIndex];

                if (Utils.isEmptyArray(currentPanel.tabList)) return;
                let currentTabIndex = Utils.findIndexInArrayById(props.tabId, currentPanel.tabList);
                if (currentTabIndex === -1) return;
                
                // Update ticket outline
                currentPanelList[currentPanelIndex].tabList[currentTabIndex].chatThreadId = chatThreadId;

                //  optimize chatAi tabList
                const optimizeFilterKnowledgeListData = currentPanelList[currentPanelIndex].tabList[currentTabIndex].component.props?.filterKnowledgeListData
                if (optimizeFilterKnowledgeListData && optimizeFilterKnowledgeListData.organizationProject) {
                    delete optimizeFilterKnowledgeListData.organizationProject
                }
                currentPanelList[currentPanelIndex].tabList[currentTabIndex].component.props.filterKnowledgeListData = optimizeFilterKnowledgeListData
                currentPanelList[currentPanelIndex].tabList[currentTabIndex].component.props.tabNameChatAI = tabNameChatAI;
                currentPanelList[currentPanelIndex].tabList[currentTabIndex].tabNameChatAI = tabNameChatAI;

                if (aiAutoLog) {
                    currentPanelList[currentPanelIndex].tabList[currentTabIndex].component.props.tabNameChatAI = aiAutoLog.tabName;
                    currentPanelList[currentPanelIndex].tabList[currentTabIndex].tabNameChatAI = aiAutoLog.tabName;
                }
                
                setPanelList([...currentPanelList]);
            })
            .catch(e => console.log('getListMessageChat err: ', e))
            .finally(() => {
                if (aiAutoLog) {
                    setIsLoading(false);
                    hideLoadingMouse();
                }
            });

        }

        return () => {
            controller.abort();
        }

    }, [chatThreadId, props?.tabId]);

    useEffect(() => {
        let aiAutoLog = filterKnowledgeListData?.aiAutoLog;
        
        let subscriptionAiAuto;
        const handleSubscriptionCreateAiAutoChatPost = (threadId) => {
            let subscription;
            subscription = APIAmplify.graphql({
                query: onAIChatPostCreated,
                variables: { chatThreadId: threadId },
                authMode: Constant.AUTH_MODE_API_KEY
            }).subscribe({
                next: async res => {
                    let newChatPost = res.value.data.onAIChatPostCreated;
                    if (!aiAutoLog) {
                        if (newChatPost.role !== 'system') return;

                        setListMessageContent(prev => {
                            let listMsg = [...prev];
    
                            let createMsg = {
                                dateTime: aiAutoLog
                                    ? Utils.getJSTDateTimeYYYY_MM_DDHHMM(newChatPost.createdAt)
                                    : Utils.getDateTimeByFormatJapanYYYY_MM_DDHHMM(
                                          newChatPost.createdAt
                                      ),
                                content: newChatPost.content,
                                isFromMe: newChatPost.role === 'user',
                                postType: newChatPost.postType || Constant.POST_TYPE.MSG,
                                id: newChatPost.id
                            };

                            const currentLastMsg = listMsg[listMsg.length - 1];

                            if (
                                currentLastMsg &&
                                currentLastMsg.isFromMe === false &&
                                currentLastMsg.isLoadingMessage === true
                            ) {
                                listMsg[listMsg.length - 1] = createMsg;
                                listMsg.push(currentLastMsg);
                            }
    
                            return listMsg;
                        });
                        return;
                    }
                   
                    if (newChatPost.content === 'MSG-AI-AUTO-LOG-PAUSE') {
                        newChatPost.content = I18n.get('MSG-AI-AUTO-LOG-PAUSE')
                    }
                    
                    setListMessageContent(prev => {
                        let listMsg = [...prev];

                        let createMsg = {
                            dateTime: aiAutoLog
                                ? Utils.getJSTDateTimeYYYY_MM_DDHHMM(newChatPost.createdAt)
                                : Utils.getDateTimeByFormatJapanYYYY_MM_DDHHMM(
                                      newChatPost.createdAt
                                  ),
                            content: newChatPost.content,
                            isFromMe: newChatPost.role === 'user'
                        };

                        if (filterKnowledgeListData.isOperatorPromptLog) {
                            createMsg.user = newChatPost.creatorId;
                            createMsg.isOperatorPromptLog = true
                        }
                        const currentLastMsg = listMsg[listMsg.length - 1];
                        // case: replace msg PAUSE to gpt loading
                        if (
                            currentLastMsg &&
                            currentLastMsg.isFromMe === false &&
                            currentLastMsg.isLoadingMessage === true
                        ) {
                            listMsg[listMsg.length - 1] = createMsg;
                        }
                        // case: push msg Replay & msg gpt loading
                        else if (
                            createMsg.content === 'MSG-AI-AUTO-LOG-REPLAY'
                        ) {
                            createMsg.isHidden = true;
                            listMsg.push(createMsg);
                            listMsg.push({
                                isFromMe: false,
                                isLoadingMessage: true
                            });
                            
                        }
                        else {
                            listMsg.push(createMsg);
                        }
                        return listMsg;
                    })
                },
                error: error => {
                    console.log('subscriptionAiAuto error:', error);
                }
            });
            return subscription
        }
        if (!Utils.isEmptyString(chatThreadId)) {
            subscriptionAiAuto = handleSubscriptionCreateAiAutoChatPost(
                chatThreadId
            );
        }
        return () => {
            if (subscriptionAiAuto) {
                subscriptionAiAuto?.unsubscribe();
            }
        };
    }, [chatThreadId, props?.tabId]);

    // Fetch MCP servers when corporation and project details are available
    useEffect(() => {
        const chatGptModelList = OpenAiUtil.getListChatGptModelFromCorpDetail(corporationDetail);
        if (chatGptModelList.length > 0) {
            setChatGPTModelListOptions(chatGptModelList);
        }
        if (filterKnowledgeListData?.projectSelectedId) {
            fetchMcpServers();
        }
    }, [filterKnowledgeListData]);


    const usingBasicPrompt = filterKnowledgeListData?.hasOwnProperty('usingBasicPrompt')
        ? filterKnowledgeListData.usingBasicPrompt
        : true;
    const resetSearchCondition = filterKnowledgeListData?.hasOwnProperty('resetSearchCondition')
        ? filterKnowledgeListData.resetSearchCondition
        : false;

    const isInvalidPrecondition = filterKnowledgeListData?.hasOwnProperty('isInvalidPrecondition')
        ? filterKnowledgeListData.isInvalidPrecondition
        : false;

    const initHitNumber = filterKnowledgeListData?.hasOwnProperty('hitNumber')
        ? filterKnowledgeListData.hitNumber
        : totalTickets
    
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const [toggleUsingKnowledgeTicketList, setToggleUsingKnowledgeTicketList] = useState(!resetSearchCondition);

    const { corporationSetting, limitValue, inviterSetting, contractType } = corporationDetail || {};
    const isGuestContract = [
        Constant.CORPORATION_CONTRACT_TYPE.GUEST,
        Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK
    ].includes(contractType);

    const chatGptModelOfCorp = isGuestContract
        ? Utils.convertJSONDataToObject(inviterSetting)?.chatGPTModel
        : Utils.convertJSONDataToObject(corporationSetting)?.chatGPTModel
        || Utils.convertJSONDataToObject(limitValue)?.chatGPTModel;

    let usingChatGptModelDefault = filterKnowledgeListData?.hasOwnProperty('usingChatGptModel')
        ? filterKnowledgeListData.usingChatGptModel
        : chatGptModelOfCorp;
    const [usingChatGptModel, setUsingChatGptModel] = useState(usingChatGptModelDefault);
    const usingReasoingEffortDefault = filterKnowledgeListData?.hasOwnProperty(
        'usingReasoningEffort'
    )
        ? filterKnowledgeListData.usingReasoningEffort
        : OpenAiUtil.defaultReasoningEffort(usingChatGptModelDefault);
    
    const [usingReasoningEffort, setUsingReasoningEffort] = useState(usingReasoingEffortDefault);
    let usingSelectedMcpListDefault = filterKnowledgeListData?.hasOwnProperty('listSelectedMcp')
        ? filterKnowledgeListData.listSelectedMcp
        : [];
    const [selectedMcpServers, setSelectedMcpServers] = useState(usingSelectedMcpListDefault);
    const [reasoningDataStream, setReasoningDataStream] = useState([]);
    useEffect(() => {
        let aiAutoLog = filterKnowledgeListData?.aiAutoLog;
        if (aiAutoLog) return;

        (async () => {
            setIsLoading(true);
            await getProjectInfo(
                props?.API,
                filterKnowledgeListData?.projectIdKnowledgeSelected,
                setProjectInfo,
                corporationDetail,
                setTitleTicket,
                setPromptInternalTicket,
                setPromptExternalTicket,
                setBasicPrompt,
                filterKnowledgeListData,
                setIsReloadPage,
                setCorporationSelected,
                projectInuseDetail.id,
                setIsUsingKnowledgeService,
                setProjectInuseDetail
            );
            setIsLoading(false);
        })();
    }, [
        props?.filterKnowledgeListData?.projectIdKnowledgeSelected,
        triggerReload,
        props?.filterKnowledgeListData?.ticketCreatedProjectId,
        props?.filterKnowledgeListData?.ticketCreatedCorporationId
    ]);
    
    const reOpenKnowledgePanel = async () => {
        setIsLoading(true);
        let isValidCondition = await isValidSearchConditionData(
            props?.API,
            projectInuseDetail,
            props?.filterKnowledgeListData?.projectIdKnowledgeSelected,
            projectInfo,
            props?.filterKnowledgeListData?.viewSelectedId,
            currentUserDetail,
            userPermissionView,
            setProjectIdListUserIsB2CAtom,
            panelList,
            setPanelList
        );

        setIsLoading(false);
        if (!isValidCondition) {
            if (projectInuseDetail.type === Constant.PROJECT_TYPE.CUSTOMER) {
                setIsReloadPage(true);
                return;
            }
            setIsInvalidSearchCondition(true);
            return;
        }

        const existedPanel = panelList.find(panel => (Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST).includes(panel.type));
        if (!Utils.isEmptyObject(existedPanel)) {
            closePanelTab({
                event: null,
                panelType: existedPanel.type,
                panelId: existedPanel.id,
                tabId: 'knowledge_ticket_list_tab'
            });
        }

        const propsClone = cloneDeep(props);
        // delete propsClone.panelId;
        delete propsClone.filterKnowledgeListData;

        let addNewPanelParams = {
            type: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST,
            componentName: Constant.COMPONENT_NAME.LIST_TICKET_KNOWLEDGE,
            tabId: 'knowledge_ticket_list_tab',
            existedKnowledgePanel: existedPanel,
            visibilitySettingType: props?.filterKnowledgeListData?.visibilityKnowledgeAtom ? props?.filterKnowledgeListData?.visibilityKnowledgeAtom : Constant.VISIBILITY_SETTING_TYPE.PRIVATE,
            isCustomer: false,
            projectSelectedId: props?.filterKnowledgeListData.projectIdKnowledgeSelected,
            corporationSelectedId: corporationSelected,
            knowledgeInfoChatAi: {
                viewSelectedId: props?.filterKnowledgeListData.viewSelectedId,
                viewSelected: props?.filterKnowledgeListData.viewSelected,
                viewStructure: props?.filterKnowledgeListData.viewStructure,
                ticketCreatedCorporationId: props?.filterKnowledgeListData.ticketCreatedCorporationId,
                ticketCreatedProjectId: props?.filterKnowledgeListData.ticketCreatedProjectId,
            }, 
            props : {
                ...propsClone,
                componentName: Constant.COMPONENT_NAME.LIST_TICKET_KNOWLEDGE,
                panelType: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST,
                panelId: propsClone.panelId,
                projectSelectedId: props?.filterKnowledgeListData.projectIdKnowledgeSelected,
                visibilitySettingType: props?.filterKnowledgeListData?.visibilityKnowledgeAtom ? props?.filterKnowledgeListData?.visibilityKnowledgeAtom : props.visibilitySettingType,
                ticketCreatedCorporationId: props?.filterKnowledgeListData.ticketCreatedCorporationId,
                ticketCreatedProjectId: props?.filterKnowledgeListData.ticketCreatedProjectId,
            },
        }

        if (props?.filterKnowledgeListData.projectIdKnowledgeSelected !== projectInuseDetail.id  ) {
            // setIsShowVisibilityKnowledgeAtom(false);
            addNewPanelParams.visibilitySettingType = Constant.VISIBILITY_SETTING_TYPE.CUSTOMER
            addNewPanelParams.isCustomer = true
        }

        addNewPanel(addNewPanelParams)

        reloadKnowledgeDrilldownIsCustomerParams({
            isCustomer: addNewPanelParams.isCustomer
        });
    };

    const onClickUrlViewTicket = async (url) => {
        setIsLoading(true)
        const {
            orgDomain: affiliationOrganizationDomain,
            projectId: affiliationProject,
            ticketId: ticketIdOfUrl,
            withMessage
        } = await Utils.extractShareLinkInfo(url);

        await openShareLinkTicket(
            API,
            ticketIdOfUrl,
            affiliationProject,
            affiliationOrganizationDomain,
            currentUserDetail.id,
            projectInuseDetail.id,
            {
                ...props,
                setIsLoading,
                API,
                setIsOpenAccessDeniedPopup,
                setIsOpenPopupKnowledgeOff,
                setIsOpenNotFoundTicketPopup,
                addNewPanel,
                setLastUserAction,
                setPanelList,
                setProjectDetail: setProjectInuseDetail,
                userDetail: currentUserDetail,
                setUserDetail: setCurrentUserDetail,
                setShowPopupSingleButtonError
            },
            withMessage
        );
    }
    window.onClickUrlViewTicket = onClickUrlViewTicket;

    return (
        <div className="chat-ai-container">
            <LoadingPanel isLoading={isLoading} />
            <FirstMessageContent tabNameChatAI={props?.tabNameChatAI} />
            {!isAiAutoLog &&  (
                <GroupButtonKnowledge
                    projectInfo={projectInfo}
                    panelId={props.panelId}
                    tabId={props.tabId}
                    resetSearchCondition={resetSearchCondition}
                    isInvalidPrecondition={isInvalidPrecondition}
                    viewSelectedIdInProps={filterKnowledgeListData?.viewSelectedId}
                    viewStructure={filterKnowledgeListData?.viewStructure}
                    API={props?.API}
                    setIsLoading={setIsLoading}
                    enqueueSnackbar={enqueueSnackbar}
                    reOpenKnowledgePanel={reOpenKnowledgePanel}
                    projectIdKnowledgeSelected={filterKnowledgeListData?.projectIdKnowledgeSelected}
                    tabNameChatAI={props?.tabNameChatAI}
                    corporationSelected={corporationSelected}
                    initHitNumber={initHitNumber}
                    isUsingKnowledgeService={isUsingKnowledgeService}
                    toggleUsingKnowledgeTicketList={toggleUsingKnowledgeTicketList}
                    setToggleUsingKnowledgeTicketList={setToggleUsingKnowledgeTicketList}
                    usingChatGptModel={usingChatGptModel}
                    setUsingChatGptModel={setUsingChatGptModel}
                    mcpServerOptions={mcpServerOptions}
                    selectedMcpServers={selectedMcpServers}
                    setSelectedMcpServers={setSelectedMcpServers}
                    isEnableMcpInVersion={isEnableMcpInVersion}
                    setUsingReasoningEffort={setUsingReasoningEffort}
                    usingReasoningEffort={usingReasoningEffort}
                    panelList={panelList}
                    setPanelList={setPanelList}
                    selectedCorporationDetail={selectedCorporationDetail}
                    chatGPTModelListOptions={chatGPTModelListOptions}
                />
            )}

            <div className="group-chat-input">
                <ListMessageChatAI
                    listMessageContent={listMessageContent}
                    setListMessageContent={setListMessageContent}
                    setIsLoadingMessage={setIsLoadingMessage}
                    isLoadingMessage={isLoadingMessage}
                    chatThreadId={chatThreadId}
                    isEnableBtnSend={isEnableBtnSend}
                    setIsEnableBtnSend={setIsEnableBtnSend}
                    panelId={props.panelId}
                    corporationDetail={corporationDetail}
                    currentUserDetail={currentUserDetail}
                    setUserSelectedPrompt={setUserSelectedPrompt}
                    idOfResponseMessage={idOfResponseMessage}
                    setIdOfResponseMessage={setIdOfResponseMessage}
                    projectInfo={projectInfo}
                    projectInuseDetail={projectInuseDetail}
                    isAiAutoLog={isAiAutoLog}
                    aiAutoPromptTitle={aiAutoPromptTitle}
                    usingChatGptModel={usingChatGptModel}
                    usingReasoningEffort={usingReasoningEffort}

                    isShowButtonStop={isShowButtonStop}
                    setIsShowButtonStop={setIsShowButtonStop}
                    isOnlyRunChatAI={isOnlyRunChatAI}
                    setIsOnlyRunChatAI={setIsOnlyRunChatAI}

                    setStreamedContent={setStreamedContent}
                    streamedContent={streamedContent}

                    isStopStreamContent={isStopStreamContent}
                    setIsStopStreamContent={setIsStopStreamContent}
                    setReasoningDataStream={setReasoningDataStream}
                    reasoningDataStream={reasoningDataStream}
                />
                {!isAiAutoLog && (
                    <InputChatAI
                        setListMessageContent={setListMessageContent}
                        panelId={props.panelId}
                        tabId={props.tabId}
                        API={props?.API}
                        projectInfo={projectInfo}
                        setTriggerReload={setTriggerReload}
                        filterKnowledgeListData={filterKnowledgeListData}
                        basicPrompt={basicPrompt}
                        isEnableBtnSend={isEnableBtnSend}
                        setIsEnableBtnSend={setIsEnableBtnSend}
                        listMessageContent={listMessageContent}
                        resetSearchCondition={resetSearchCondition}
                        corporationSelected={corporationSelected}
                        tabNameChatAI={props?.tabNameChatAI}
                        titleTicket={titleTicket}
                        setUserSelectedPrompt={setUserSelectedPrompt}
                        userSelectedPrompt={userSelectedPrompt}
                        promptInternalTicket={promptInternalTicket}
                        promptExternalTicket={promptExternalTicket}
                        setIsOpenModalReloadPage={setIsOpenModalReloadPage}
                        isLoading={isLoading}
                        setIsLoading={setIsLoading}
                        usingBasicPrompt={usingBasicPrompt}
                        idOfResponseMessage={idOfResponseMessage}
                        setIdOfResponseMessage={setIdOfResponseMessage}
                        isUsingKnowledgeServiceValue={isUsingKnowledgeService}
                        toggleUsingKnowledgeTicketList={toggleUsingKnowledgeTicketList}
                        usingChatGptModel={usingChatGptModel}
                        setUsingChatGptModel={setUsingChatGptModel}
                        selectedMcpServers={selectedMcpServers}
                        setSelectedMcpServers={setSelectedMcpServers}
                        mcpServerOptions={mcpServerOptions}
                        usingReasoningEffort={usingReasoningEffort}
                        setUsingReasoningEffort={setUsingReasoningEffort}

                        isShowButtonStop={isShowButtonStop}
                        setIsShowButtonStop={setIsShowButtonStop}
                        isOnlyRunChatAI={isOnlyRunChatAI}
                        setIsOnlyRunChatAI={setIsOnlyRunChatAI}

                        setStreamedContent={setStreamedContent}
                        streamedContent={streamedContent}

                        isStopStreamContent={isStopStreamContent}
                        setIsStopStreamContent={setIsStopStreamContent}
                        reasoningDataStream={reasoningDataStream}
                        setReasoningDataStream={setReasoningDataStream}
                    />
                )}
            </div>
            <ConfirmDialog
                isOpen={isReloadPage}
                msgConfirm={I18n.get('COMMSG030')}
                okCallBack={() => window.location.reload()}
            />

            <ConfirmDialog
                isOpen={isInvalidSearchCondition}
                msgConfirm={I18n.get('MSG-ERROR-WHEN-KNOWLEDGE-BEING-USED-BE-HIDDEN-OR-DELETED')}
                okCallBack={() => {
                    updateChatAIInvalidPreconditionStatus(
                        panelList,
                        setPanelList,
                        props.panelId,
                        props.tabId,
                        true
                    );
                    setIsInvalidSearchCondition(false);
                }}
            />

            <DataChangePleaseReloadModal
                isOpen={isOpenModalReloadPage}
                setIsOpen={setIsOpenModalReloadPage}
            />
            <ConfirmDialog
                isOpen={isOpenPopupKnowledgeOff}
                msgConfirm={I18n.get('USER14MSG028')}
                okCallBack={e => {
                    setIsOpenPopupKnowledgeOff(false);
                }}
                textSubmit={'はい'}
            />
            <ConfirmDialog
                isOpen={isOpenAccessDeniedPopup}
                msgConfirm={I18n.get('KNOWDEMSG005')}
                okCallBack={e => setIsOpenAccessDeniedPopup(false)}
                textSubmit={I18n.get('CM-BUTTON-OK')}
            />
            <ConfirmDialog
                isOpen={isOpenNotFoundTicketPopup}
                msgConfirm={I18n.get('MSG-CM-DELETED-CONTENT')}
                okCallBack={e => setIsOpenNotFoundTicketPopup(false)}
                textSubmit={I18n.get('CM-BUTTON-OK')}
            />
            <ConfirmDialog
                isOpen={showPopupSingleButtonError?.isShow}
                msgConfirm={showPopupSingleButtonError?.message}
                okCallBack={e =>
                    setShowPopupSingleButtonError(pre => {
                        return {
                            ...pre,
                            isShow: false
                        };
                    })
                }
                textSubmit={showPopupSingleButtonError?.confirmTxt}
            />
        </div>
    );
}
